import { render, staticRenderFns } from "./ServicoQuickCreate.vue?vue&type=template&id=23bc403e"
import script from "./ServicoQuickCreate.vue?vue&type=script&lang=js"
export * from "./ServicoQuickCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports